import { defineStore } from 'pinia'
import type { CategoryItem, CategoryTree } from '~/types/searchTypes'
import fetchCategoriesByKey from '~/utils/category/fetchCategoriesByKey'

function getInitialState(): ICategoriesByKeysStoreState {
  return {
    dataSets: [],
  }
}

export const useCategoriesByKeysStore = defineStore('categoriesByKeysStore', {
  state: (): ICategoriesByKeysStoreState => getInitialState(),
  getters: {
    getDataSets(state): CategoryTree[] {
      return state.dataSets
    },
  },
  actions: {
    async getByCategoryDocAndLocale(categoryDocKey: string, locale: string) {
      let currentDataSet = this.dataSets.find(
        (predicate) => predicate.categoryDocKey === categoryDocKey && predicate.locale === locale
      )

      if (currentDataSet === undefined) {
        const categories: CategoryItem[] = await fetchCategoriesByKey(categoryDocKey, locale)

        currentDataSet = {
          categoryDocKey,
          locale,
          items: categories,
        }

        this.dataSets.push(currentDataSet)
      }

      return currentDataSet.items
    },
  },
})

export interface ICategoriesByKeysStoreState {
  dataSets: {
    categoryDocKey: string
    locale: string
    items: CategoryItem[]
  }[]
}
